import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { API } from "../APICalls";
import lebenRaffleIcon from '../assets/logo.png';

export default function User(){


    document.getElementsByTagName("body")[0].classList.remove("login-page");
    document.getElementsByTagName("body")[0].classList.add("sidebar-mini");

    let navigate = useNavigate();

    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [userId, setUserId] = useState('');
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    

    const [nameError, setNameError] = useState(false);
    const [surnameError, setSurnameError] = useState(false);
    const [userIdError, setUserIdError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [emailError, setEmailError] = useState(false);


    const[account, setAccount] = useState(null);
    const[user, setUser] = useState(null);

    var {accountId} = useParams();
    

    useEffect(() => {
        API.GetUser(accountId).then((response) => {
            if(response.ok){
                response.json().then((data) => {
                    setUser(data);
                    setName(data.Name);
                    setSurname(data.Surname);
                });
            }
            else{
                alert("Token is not valid");
            }
        })
        .catch(() =>
        {
            alert("Cannot connect to LebenRaffle API");
        });

        API.GetAccount(accountId).then((response) => {
            if(response.ok){
                response.json().then((data) => {
                    setAccount(data);
                    setEmail(data.Email);
                    setUserId(data.UserId);
                });
            }
            else{
                alert("Token is not valid");
            }
        })
        .catch(() =>
        {
            alert("Cannot connect to LebenRaffle API");
        });

    }, []);




    const saveUser = (event) => {
        event.preventDefault();


        // Reset Errors
        var errors = false;
        setNameError(false);
        setSurnameError(false);
        setUserIdError(false);
        setPasswordError(false);
        setEmailError(false);


        // Check Errors
        if(name == null || name == '')
        {
            errors |= true;
            setNameError(true);
        }
        if(surname == null || surname == '')
        {
            errors |= true;
            setSurnameError(true);
        }
        if(password == null || password == '')
        {
            errors |= true;
            setPasswordError(true);
        }
        if(email == null || email == '')
        {
            errors |= true;
            setEmailError(true);
        }
        if(userId == null || userId == '')
        {
            errors |= true;
            setUserIdError(true);
        }

        //Save form
        if(!errors)
        {

            API.PostAccount(account.Id, userId, email, password).then((response) => {
                if(response.ok){
                    API.PostUser(account.Id, name, surname).then((response) => {
                        if(response.ok)
                            navigate('/users');
                        else
                            alert("Token is not valid");
                    })
                    .catch(()=>{
                        alert("Cannot connect to LebenRaffle API");
                    });
                }
                else{
                    response.text().then((error) => alert(JSON.parse(error).Message));
                }
            })
            .catch(() =>
            {
                alert("Cannot connect to LebenRaffle API");
            });
        }

    }
    


    if(user == null || account == null)
    {
        return(
            <div class="preloader flex-column justify-content-center align-items-center">
                <img class="animation__shake" src={lebenRaffleIcon} alt="LebenRaffle Logo" height="60" width="60" />
            </div>
        );
    }
    else
    {

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Crear Usuario</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item active">Crear usuario</li>
                            </ol>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="container-fluid">
                        <form onSubmit={saveUser}>
                            <div className="row">
                                <div className="col-lg-6 col-12">
                                    <div className="card card-primary card-outline">
                                        <div className="card-header">
                                            <h5 className="m-0">Datos de acceso</h5>
                                        </div>
                                        <div className="card-body">
                                            <div class="form-group">
                                                <label for="exampleInputEmail1">Email</label>
                                                <input type="text" class="form-control" id="exampleInputEmail1" value={email} onChange={e => setEmail(e.target.value)} placeholder="mail@ejemplo.com" />
                                                {emailError ? (
                                                    <span id="exampleInputEmail1-error" class="small text-danger">Este campo es obligatorio</span>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                            <div class="form-group">
                                                <label for="exampleInputEmail1">Id Usuario</label>
                                                <input type="text" class="form-control" id="exampleInputEmail1" value={userId} onChange={e => setUserId(e.target.value)} placeholder="Usuario" />
                                                {userIdError ? (
                                                    <span id="exampleInputEmail1-error" class="small text-danger">Este campo es obligatorio</span>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                            <div class="form-group">
                                                <label for="exampleInputEmail1">Password</label>
                                                <input type="password" class="form-control" id="exampleInputEmail1" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" />
                                                {passwordError ? (
                                                    <span id="exampleInputEmail1-error" class="small text-danger">Este campo es obligatorio</span>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-12">
                                    <div className="card card-primary card-outline">
                                        <div className="card-header">
                                            <h5 className="m-0">Datos personales</h5>
                                        </div>
                                        <div className="card-body">
                                            <div class="form-group">
                                                <label for="exampleInputEmail1">Nombre</label>
                                                <input type="text" class="form-control" id="exampleInputEmail1" value={name} onChange={e => setName(e.target.value)} placeholder="Nombre" />
                                                {nameError ? (
                                                    <span id="exampleInputEmail1-error" class="small text-danger">Este campo es obligatorio</span>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                            <div class="form-group">
                                                <label for="exampleInputEmail1">Apellido</label>
                                                <input type="text" class="form-control" id="exampleInputEmail1" value={surname} onChange={e => setSurname(e.target.value)} placeholder="Apellido" />
                                                {surnameError ? (
                                                    <span id="exampleInputEmail1-error" class="small text-danger">Este campo es obligatorio</span>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                            <hr style={{marginTop: 45}} />
                                            <button type="submit" className="btn btn-warning float-right">Actualizar Usuario</button> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

}